<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="1400"
      content-class="sessionRecapCard"
      @click:outside="closeDialog"
    >
      <v-card width="1400">
        <v-card-title class="third white--text font-weight-bold">
          <v-icon size="24" color="white">mdi-calendar-plus</v-icon>
          <span class="ml-2">{{ title }}</span>
          <v-spacer />
          <v-icon size="28" color="white" class="justify-end" @click="closeDialog">mdi-close</v-icon>
        </v-card-title>

        <v-card-text class="pt-6">
          <SessionCreateForm v-if="dialog" :session="session" mode="create" :close-dialog="closeDialog" :mandatory-type-session="mandatoryTypeSession" :select-session-date="selectSessionDate" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import { add, getUnixTime } from 'date-fns';
import { EventBus } from '../../helpers/utils';
import store from '@/store';
import SessionCreateForm from './createForm/SessionCreateForm.vue';

export default {
  components: { SessionCreateForm },
  setup () {
    const selectedDate = computed(() => store.getters.selectedDate);

    const dialog = ref(null);
    const confirmationModal = ref(false);

    const sessionDateTimestamp = computed(() => getUnixTime(new Date(selectedDate.value)));

    const originalSession = ref({
      name: null,
      start_time: null,
      end_time: null,
      wtype: 'session',
      type: null,
      observation: null,
      date: sessionDateTimestamp.value
    });

    const session = ref({ ...originalSession.value });

    const closeDialog = () => {
      dialog.value = false;
      session.value = { ...originalSession.value };
    };

    const mandatoryTypeSession = ref(false);
    const selectSessionDate = ref(false);
    const title = ref('Créer la session');

    EventBus.$on('showSessionCreate', receivedObject => {
      session.value = { ...originalSession.value };
      dialog.value = true;
      const startTime = new Date(`${selectedDate.value}T${receivedObject.time}`);
      const endTime = add(new Date(`${selectedDate.value}T${receivedObject.time}`), { hours: 1 });

      session.value.start_time = getUnixTime(startTime);
      session.value.end_time = getUnixTime(endTime);
      // helpers
      session.value.end_date = getUnixTime(endTime);
      session.value.date = sessionDateTimestamp.value;
      if(receivedObject.typeSession) {
        session.value.type = receivedObject.typeSession.type;
        mandatoryTypeSession.value = receivedObject.typeSession.mandatory;
      }

      if(receivedObject.selectSessionDate) {
        selectSessionDate.value = true;
      }

      if(receivedObject.title) {
        title.value = receivedObject.title;
      }

      if(receivedObject.horses) {
        session.value.horses = receivedObject.horses;
      }
    });

    return { confirmationModal, dialog, closeDialog, session, mandatoryTypeSession, title, selectSessionDate };
  }
};
</script>
